"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateMessagingTokenWatcher = void 0;
var react_1 = require("react");
var useUpdatePushTokens_1 = require("../../hooks/useUpdatePushTokens");
var react_redux_1 = require("react-redux");
var getIsExistingToken_1 = require("../../utilities/get/getIsExistingToken");
var analyticsEventBase_1 = require("../../sdks/firebase/analyticsEventBase");
var description = 'UpdateMessagingTokenWatcher';
var UpdateMessagingTokenWatcher = function (_a) {
    var submit = (0, useUpdatePushTokens_1.useUpdatePushTokens)({ parentDescription: description }).submit;
    var newToken = (0, react_redux_1.useSelector)(function (state) {
        var _a, _b, _c, _d, _e;
        if ((_a = state.currentUnscopeUser) === null || _a === void 0 ? void 0 : _a.created) {
            var isExistingToken = (0, getIsExistingToken_1.getIsExistingToken)({
                unscopeUser: state.currentUnscopeUser,
                findToken: ((_b = state.windowMeta) === null || _b === void 0 ? void 0 : _b.firebaseMessagingToken) || undefined,
            });
            if (!isExistingToken &&
                !((_c = state.currentUser) === null || _c === void 0 ? void 0 : _c.signingOut) &&
                ((_d = state.windowMeta) === null || _d === void 0 ? void 0 : _d.firebaseMessagingToken)) {
                return (_e = state.windowMeta) === null || _e === void 0 ? void 0 : _e.firebaseMessagingToken;
            }
        }
        return null;
    });
    var _b = (0, react_1.useState)(), previousToken = _b[0], setPreviousToken = _b[1];
    (0, react_1.useEffect)(function () {
        if (newToken && newToken !== previousToken) {
            (0, analyticsEventBase_1.analyticsEventBase)({
                event: 'Update messaging token',
            });
            submit({ token: newToken });
            setPreviousToken(newToken);
        }
    }, [newToken, previousToken, setPreviousToken]);
    return null;
};
exports.UpdateMessagingTokenWatcher = UpdateMessagingTokenWatcher;
